import { g } from '@pretto/bricks/components/layout'
import * as typo from '@pretto/bricks/core/typography'
import InputSlider from '@pretto/bricks/shared/components/InputSlider'
import styled from 'styled-components'

export const Slider = styled(InputSlider)``
export const Description = styled.p`
  ${typo.caption12};
  color: ${({ theme }) => theme.colors.neutral2};
  margin-top: ${g(0.5)};
`
